import React from "react";
import { useNavigate } from "react-router-dom";
import { AttachMoneyOutlined, AccountBalanceWalletOutlined, InventoryOutlined } from "@mui/icons-material";

import { PURCHASE_ORDERS_ROUTES } from "src/pages/purchaseOrders/constants";

import { CardLayout, OverviewCard } from "../v3";

export const VendorOverview = () => {
  const navigate = useNavigate();

  const handlePurchaseOrderClick = () => {
    navigate(PURCHASE_ORDERS_ROUTES.root);
  };
  return (
    <>
      <CardLayout
        sx={{
          position: "absolute",
          bottom: "-20px",
          left: "0px",
          right: "0px",
          padding: "0px",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "12px",
        }}
      >
        <OverviewCard
          title="Total Purchase Orders"
          value="150"
          extraValue="50"
          extraColor="#18DA4E"
          icon={<InventoryOutlined sx={{ fontSize: "1rem", color: "#783DC4" }} />}
          showButton
          onViewClick={handlePurchaseOrderClick}
        />
        <OverviewCard
          title="Total Paid"
          value="$1200"
          icon={<AccountBalanceWalletOutlined sx={{ fontSize: "1rem", color: "#783DC4" }} />}
        />
        <OverviewCard
          title="Total Balance"
          value="$500"
          icon={<AttachMoneyOutlined sx={{ fontSize: "1rem", color: "#783DC4" }} />}
        />
      </CardLayout>
    </>
  );
};
